import type { ITicket, ITicketsResponse } from "@/app/shared/types/Bets.type"
import { fetchPlayerBets } from "@/app/api"
import { useUserService } from "@/user-account/composables/useUserService"
import { computed, ref } from "vue"
import { useBetStore } from "../../../store"

export function useCasinoBets() {
  const ITEMS_PER_PAGE = 10
  const store = useBetStore()
  const { isAuthenticated } = useUserService()

  const state = ref({
    tickets: [] as ITicket[],
    loading: false,
    totalCount: 0,
    currentPage: 1,
  })

  const hasMoreTickets = computed(() =>
    state.value.tickets.length < state.value.totalCount && state.value.tickets.length !== 0,
  )

  const showEmptyState = computed(() =>
    state.value.tickets.length === 0 && !state.value.loading,
  )

  async function fetchBets(page = 1): Promise<void> {
    if (!isAuthenticated()) {
      store.handleShowLogin()
      return
    }

    try {
      state.value.loading = true

      const params = {
        per_page: ITEMS_PER_PAGE,
        page,
      }

      const { data } = await fetchPlayerBets(params) as ITicketsResponse
      state.value.tickets = [...state.value.tickets, ...data.data]
      state.value.totalCount = data.meta.total
      state.value.currentPage = data.meta.current_page
    }
    catch (error) {
      console.error("Failed to fetch bets:", error)
    }
    finally {
      state.value.loading = false
    }
  }

  async function handleFetchMore(): Promise<void> {
    if (state.value.loading)
      return

    state.value.currentPage++
    await fetchBets(state.value.currentPage)
  }

  return {
    state,
    hasMoreTickets,
    showEmptyState,
    fetchBets,
    handleFetchMore,
  }
}
